import { Input, SecondaryButton, Stack } from "flicket-ui";
import { ChangeEvent, KeyboardEvent, useState } from "react";

export const SinglePageCheckoutOrderSummaryPromoCodeInput = () => {
  // TODO: extract the logic to a store
  const [inputValue, setInputValue] = useState("");
  const [activityState] = useState<
    "idle" | "applying" | "removing" | "applied"
  >("idle");

  const applyPromoCode = () => {
    console.log("applied", inputValue);
  };

  return (
    <Stack gap={1}>
      <Input
        value={inputValue}
        disabled={activityState !== "idle"}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setInputValue(e.target.value)
        }
        placeholder="Have a promo code?"
        onKeyPress={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            void applyPromoCode();
          }
        }}
      />
      <SecondaryButton
        disabled={activityState !== "idle"}
        onClick={() => {
          void applyPromoCode();
        }}
        isLoading={activityState === "applying"}
        borderColor="N300"
        color="N800"
      >
        Apply
      </SecondaryButton>
    </Stack>
  );
};
